
// Sliders
// Splide JS
//
// See: https://splidejs.com/guides/getting-started/
//

// Init Splide Slider
function initSplideCarouselRwd() {
  // Get all carousel elements
  const carouselElts = document.getElementsByClassName('js_carousel_rwd');

  // Utility: Get valid data attribute or fallback
  function getValidDataAttribute(attr, fallback) {
    const value = parseInt(attr, 10);
    return isNaN(value) ? fallback : value;
  }

  // Loop through each element
  for (let i = 0; i < carouselElts.length; i++) {
    const carouselElt = carouselElts[i]; // Current slider element

    if (carouselElt) {
      // Inject Loader Div
      const loaderDiv = document.createElement('div');
      loaderDiv.className = 'js_splide_loader';
      loaderDiv.textContent = 'Chargement...';
      carouselElt.appendChild(loaderDiv);

      // Init Per Page values with validation and fallback
      const EltOptionsItemsSm = getValidDataAttribute(carouselElt.getAttribute('data-splide-item-sm'), 1);
      const EltOptionsItemsMd = getValidDataAttribute(carouselElt.getAttribute('data-splide-item-md'), 2);
      const EltOptionsItemsLg = getValidDataAttribute(carouselElt.getAttribute('data-splide-item-lg'), 3);
      const EltOptionsItemsXl = getValidDataAttribute(carouselElt.getAttribute('data-splide-item-xl'), 3);

      // Initialize Splide for the current element
      const splide = new Splide(carouselElt, {
        type: 'slide',
        perPage: EltOptionsItemsXl,
        arrows: true,
        pagination: true,
        drag: false,
        classes: {
          arrows: 'splide__arrows  list-unstyled d-flex justify-content-center justify-content-md-between',
          arrow : 'splide__arrow  btn btn-primary btn-round',
        },
        i18n: {
          slideLabel: 'Numéro %s de %s items',
          first: 'Aller au premier item du diaporama',
          last: 'Aller au dernier item du diaporama',
          slideX: 'Aller à l\'item numéro %s',
          pageX: 'Aller à la page %s',
          select: 'Sélectionner un item du diaporama',
          prev: 'Item précédent',
          next: 'Item suivant',
        },
        breakpoints: {
          1440: {
            perPage: EltOptionsItemsXl
          },
          1280: {
            perPage: EltOptionsItemsLg
          },
          1024: {
            perPage: EltOptionsItemsMd
          },
          768: {
            perPage: EltOptionsItemsSm,
            arrows: false,
            drag: true
          },
          666: {
            perPage: 1,
            arrows: false,
            drag: true
          },
          320: {
            perPage: 1,
            arrows: false,
            drag: true
          },
        },
      });

      splide.on('overflow', function (isOverflow) {
        splide.options = {
          arrows: isOverflow,
          pagination: isOverflow,
          drag: isOverflow,
        };
      });

      // Handle when Splide is ready
      splide.on('mounted', function () {
        //console.log(`Splide mounted for element [${carouselElt.className}]`);
        //console.log('EltOptionsItemsSm : ', EltOptionsItemsSm);
        //console.log('EltOptionsItemsMd : ', EltOptionsItemsMd);
        //console.log('EltOptionsItemsLg : ', EltOptionsItemsLg);
        if (loaderDiv && loaderDiv.parentNode) {
          loaderDiv.parentNode.removeChild(loaderDiv);
        }
      });

      // Mount Splide
      splide.mount();
    }
  }
}
